import { PersonRecord, User } from "../types/data";

function normalizeOptionalNumber(value: unknown): number | undefined {
  return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}

function normalizeOptionalString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}

export function createPersonRecordFromUser(opts: {
  user: User;
  surveyorId: string;
  nowIso?: string;
}): PersonRecord {
  const { user, surveyorId } = opts;
  const now = opts.nowIso ?? new Date().toISOString();

  const userAny = user as any;

  // The app treats PersonRecord ids as UUIDs.
  const personId: string =
    (typeof userAny.uuid === "string" && userAny.uuid.length > 0)
      ? userAny.uuid
      : String(user.id);

  const mobile =
    normalizeOptionalString(userAny.mobile) ??
    normalizeOptionalString(userAny.phone) ??
    normalizeOptionalString(user.email) ??
    "";

  // IMPORTANT: Many UI components assume `person.address` exists.
  const address = {
    district: normalizeOptionalString(userAny.address?.district) ?? "",
    upazila: normalizeOptionalString(userAny.address?.upazila) ?? "",
    union: normalizeOptionalString(userAny.address?.union) ?? "",
    village: normalizeOptionalString(userAny.address?.village) ?? "",
    gps_coordinates: normalizeOptionalString(userAny.address?.gps_coordinates) ?? "",
  };

  return {
    version: 1,
    id: personId,
    name: user.name,
    surveyor_id: surveyorId,
    mobile,
    sex: userAny.sex,
    age: normalizeOptionalNumber(userAny.age),
    occupation: userAny.occupation,
    income: normalizeOptionalNumber(userAny.income),
    address,
    notes: normalizeOptionalString(userAny.notes) ?? "",
    records: Array.isArray(userAny.records) ? userAny.records : [],
    added_on: now,
    updated_at: now,
  };
}
